import { useQuery } from "@tanstack/react-query";
import { useInstitutionStore } from "@/modules/auth/presentation/store/institution.store";
import { authContainer } from "@/modules/auth/di/container";
import { sinaremReportsContainer } from "../../di/container";

export function useThemeComparison(editionId: string) {
  const { institutionName } = useInstitutionStore();
  const isAuthenticated = institutionName
    ? authContainer.repository.isAuthenticated(institutionName)
    : false;

  return useQuery({
    queryKey: [
      "sinarem-reports",
      "theme-comparison",
      institutionName,
      editionId,
    ],
    queryFn: () =>
      sinaremReportsContainer.repository.getThemeComparison(editionId),
    enabled: isAuthenticated && !!editionId,
    retry: false,
  });
}
